import moment from 'moment'
import okeResponse from 'okeoke.standardresponse'
import { OrderStatus, OrderStates } from '../consts'
import ordereduuid from '../Helpers/timeuuid'
import cloneDeep from 'lodash.clonedeep'

export default function statusesProcessor(order, offlineEnabled, clientSocket, client) {
  const findInsertIndexByInsertTimestamp = (array, insertTimestamp) => {
    let index = 0
    try {
      for (let value of array) {
        let isafter = moment(insertTimestamp).isAfter(value.insertTimestamp)
        if (!isafter) break
        index++
      }
    } catch(e) {
      //Just skip
    }
    return index
  }

  function insertFromCloud(status, orderObj = null) {
    if (status == null) return null
    let exists = getStatus('', status.uuid, orderObj)
    if (exists == null) {
      let insertIndex = findInsertIndexByInsertTimestamp(
        orderObj?.statuses || order.order.statuses,
        status.insertTimestamp
      )
      if (orderObj) {
        orderObj.statuses.splice(insertIndex, 0, status)
      } else {
        order.order.statuses.splice(insertIndex, 0, status)
      }
      return status
    } else {
      return null
    }
  }

  function insertStatus(status) {
    //console.log({ ...status })
    let newStatus = {
      ...status,
      uuid: ordereduuid(),
      insertTimestamp: new Date().getTime()
    }
    //console.log({newStatus})
    order.addUpdate({ statuses: { [newStatus.uuid]: newStatus } })
    return newStatus
  }

  const deviceLetter = {
    1: 'K',
    2: 'O',
    3: 'P',
    1000: 'A',
    1001: 'W',
    1002: 'F',
  }

  // Add new status on the current server
  function addStatus(statusID, notes) {
    return new Promise((resolve, reject) => {
      if (offlineEnabled) {
        let status = insertStatus({ statusID, notes, sysUserUUID: client.localUser?.userUUID || null, deviceUUID: order.deviceInfo?.deviceUUID || null, offline: 1 })
        if (status != null && statusID === OrderStatus.ORDER_INSERTED && order.order.orderNumber == null) {
          order.addUpdate({ orderNumber: `${moment().format('YYMMDD')}/${deviceLetter[order.order.insertDeviceType] || 'T'}/${Math.round(Math.random() * 10000)}` })
        }
        // Check if order should be auto received
        //console.log('LOCATIONS:', order?.order?.location)
        //console.log('RECEIVE NEEDED:', (!order?.order?.location?.status?.rec))
        if (statusID === OrderStatus.ORDER_INSERTED) {
          order.order.insertTimestamp = new Date().getTime()
          //order.addUpdate({ insertTimestamp: new Date().getTime() })
          if (!order?.order?.location?.status?.rec) { // Auto receive on offline capable devices
            addStatus(OrderStatus.ORDER_RECEIVED, null)
          }
        }
        if (statusID === OrderStatus.ORDER_RECEIVED) {
          order.printSlips = true
        }
        if (statusID > OrderStatus.ORDER_CLOSED_SUCCESS) {
          order.printSlips = true
        }
        if ([OrderStatus.ORDER_RECEIVED, OrderStatus.ORDER_PAYMENT_EXTERNAL, OrderStatus.ORDER_DONE, OrderStatus.ORDER_PAYMENT_CONFIRMED, OrderStatus.ORDER_INVOICE_CREATED].includes(statusID)) {
          order.checkCloseOrder = order.checkCloseOrder ? order.checkCloseOrder + 1 : 1
        }
        if(statusID === OrderStatus.ORDER_FRUITSYS_FORWARD_SUCCESS) {
          if(notes.sendDirect) {
            order.addUpdate({ orderNumber: `${order.order.orderNumber}/${notes.result.data.rendelesszam}` })
          }
        }
        resolve(
          status != null
            ? okeResponse(true, 200, 'OK', status)
            : okeResponse(false, 403, 'Invalid input', null)
        )
      } else {
        if (clientSocket.authorized) {
          try {
            setTimeout(() => {
              resolve({ success: false, message: 'Timeout!', code: 408, data: { errMsgCode: 'request.error.timeout' } })
            }, 15000)
            clientSocket.ioclient.emit(
              'addStatus',
              {
                orderUUID: order.order.uuid,
                statusID,
                notes
              },
              (res) => resolve(res)
            )
          } catch (e) {
            //console.log(e)
            resolve(okeResponse(false, 500, 'Internal error', null))
          }
        } else {
          resolve(okeResponse(false, 503, 'Not connected', {}))
        }
      }
    })
  }

  async function addItemStatus(orderItemUUID, statusID, notes) {
    if (order.items.getItem(orderItemUUID) == null) return okeResponse(false, 404, 'Order item not found', null)
    let res = await addStatus(statusID, { ...notes, uuid: orderItemUUID })
    if(res.success) {
      if(statusID === OrderStatus.ORDER_ITEM_STORNO) {
        if(order.order.orderState > OrderStates.BASKET && order.order.orderState < OrderStates.CLOSED_SUCCESS) {
          client.orders.callCallbacks('onOrderItemStornoPrintSlips', { orderUUID: order.order.uuid, orderItemUUID })
        }
      }
    }
    return res
  }

  function getStatus(statusID = '', uuid = '', orderObj = null) {
    if (orderObj) {
      for (let status of orderObj.statuses) {
        let match =
          (statusID !== '' ? status.statusID === statusID : true) &&
          (uuid !== '' ? status.uuid === uuid : true)
        if (match) return cloneDeep(status) // Found
      }
    } else {
      for (let status of order.order.statuses) {
        let match =
          (statusID !== '' ? status.statusID === statusID : true) &&
          (uuid !== '' ? status.uuid === uuid : true)
        if (match) return cloneDeep(status) // Found
      }
    }
    return null // Not found
  }

  function getStatuses(statusID = '') {
    let statuses = []
    for (let status of order.order.statuses) {
      let match = statusID !== '' ? status.statusID === statusID : true
      if (match) statuses.push(status)
    }
    return statuses
  }

  function getItemStatuses(orderItemUUID) {
    let statuses = []
    for (let status of order.order.statuses) {
      let match = (status.statusID > OrderStatus.ORDER_ITEM_INFO && status.statusID <= OrderStatus.ORDER_ITEM_STORNO && status.notes.uuid === orderItemUUID)
      if (match) statuses.push(status)
    }
    return statuses
  }

  return {
    insertFromCloud,
    addStatus,
    getStatus,
    getStatuses,
    getItemStatuses,
    addItemStatus
  }
}
